import { render, staticRenderFns } from "./SensorInStock.vue?vue&type=template&id=123a9090&"
import script from "./SensorInStock.vue?vue&type=script&lang=js&"
export * from "./SensorInStock.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports